import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

const rotateAnimation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dashAnimation = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
`;

const colorAnimation = keyframes`
  100%, 0% {
    stroke: ${colors.lychee__fb6a87};
  }
  40% {
    stroke: ${colors.lychee__fb6a87};
  }
  66% {
    stroke: ${colors.lychee__fb6a87};
  }
  80%, 90% {
    stroke: ${colors.lychee__fb6a87};
  }
`;

const Circular = styled.svg`
  animation: ${rotateAnimation} 2s linear infinite;
  position: relative;
`;

const Circle = styled.circle.attrs({
  fill: 'none',
})`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: ${dashAnimation} 1.5s ease-in-out infinite, ${colorAnimation} 6s ease-in-out infinite;
  stroke-linecap: round;
`;

const CircularProgress = (props: { size: number }) => (
  <div style={{ width: props.size, height: props.size }}>
    <Circular width={props.size} height={props.size}>
      <Circle cx={props.size / 2} cy={props.size / 2} r={props.size / 4} strokeWidth={props.size / 25} />
    </Circular>
  </div>
);

export default CircularProgress;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/base/CircularProgress.tsx